import { useAuth } from "../../services/auth";

const Header = () => {
  const { authData } = useAuth();
  return (
    <div
      className={
        "py-[26px] px-[54px] border border-bottom border-slate-400 shadow-md bg-backgroundTertiary flex flex-row justify-between"
      }
    >
      <input
        placeholder="Search"
        className="px-2 py-1 rounded-md bg-backgroundSecondary"
      />
      <h2 className="">{authData?.name ?? ""}</h2>
    </div>
  );
};

export default Header;
